import moment from "moment";
import { useEffect, useState } from "react";
import { FaCalendarAlt, FaEnvelope, FaRegBuilding } from "react-icons/fa";
import { MdLocationPin, MdPhoneInTalk } from "react-icons/md";
import { RiBillLine } from "react-icons/ri";
import { Link } from "react-router-dom";
import API from "../../utils/api";
import SocialSection from "../SocialSection";
import classes from "./Footer.module.css";
export default function Footer() {
  const currentYear = moment().format("YYYY");

  const [categories, setCategories] = useState([]);

  // useEffect(() => {
  //   async function fetchCategories() {
  //     try {
  //       const res = await API.post("/categories.php", { action: "fetch" });
  //       const cats = Array.isArray(res.data) ? res.data : res.data?.data || [];
  //       setCategories(cats.slice(0, 6));
  //     } catch (err) {
  //       console.error("Failed to fetch categories:", err);
  //     }
  //   }
  //   fetchCategories();
  // }, []);

  useEffect(() => {
    async function fetchCategories() {
      try {
        const res = await API.post("/categories.php", { action: "fetch" });
        const cats = Array.isArray(res.data) ? res.data : res.data?.data || [];
        const filteredCats = cats
          .filter((cat) => cat.categoryName !== "Uncategorized")
          .slice(0, 6);
        setCategories(filteredCats);
      } catch (err) {
        console.error("Failed to fetch categories:", err);
      }
    }
    fetchCategories();
  }, []);

  return (
    <div className="container-fluid p-0">
      <div className={classes.footerContainer}>
        <div className={classes.footerMainContent}>
          <div className={classes.footerTop}>
            <div className={classes.footerSection1}>
              <img
                src="/serverstock_uk_color_logo.png"
                alt="Server Stock"
                className={classes.footerLogo}
              />
              <p>
                Server Stock is an online retailer of IT hardware and networking
                devices. We mainly deal with brands such as Dell, IBM, HP and
                many others. Our commitment is to provide the best IT devices
                and services to our customers.
              </p>
              <SocialSection />
            </div>

            <div className={classes.footerSection2}>
              <h4>Categories</h4>
              <ul>
                {categories.length > 0 ? (
                  categories.map((cat) => (
                    <li key={cat.id}>
                      <Link to={`/category/${cat.category_slug}`}>
                        {cat.categoryName}
                      </Link>
                    </li>
                  ))
                ) : (
                  <li>No categories found</li>
                )}
              </ul>
              <Link
                to="https://www.trustpilot.com/review/serverstock.co.uk"
                target="_blank"
              >
                <img
                  src="/trust-logo.svg"
                  alt="Trust Pilot Logo"
                  className={classes.trustLogo}
                  loading="lazy"
                />
              </Link>
            </div>

            <div className={classes.footerSection3}>
              <h4>Customer Services</h4>
              <ul>
                <li>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/refund-and-returns-policy">
                    Return & Refund Policy
                  </Link>
                </li>
                <li>
                  <Link to="/terms-and-conditions">Terms and Conditions</Link>
                </li>
                <li>
                  <Link to="/shipping-policy">Shipping Policy</Link>
                </li>
                <li>
                  <Link to="/warranty-information">Warranty Information</Link>
                </li>{" "}
                <li>
                  <Link to="/about">About Us</Link>
                </li>
                <li>
                  <Link to="/contact">Contact Us</Link>
                </li>
              </ul>
            </div>

            <div className={classes.footerSection4}>
              <h4>Contact Information</h4>
              <ul>
                <li className={classes.contactList}>
                  <MdLocationPin />
                  <Link
                    to="https://maps.app.goo.gl/oebouk8vyBVFZFbdA"
                    target="_blank"
                  >
                    Unit #5, The Hub, A53-61 College Road, Harrow, HA1 1AR
                  </Link>
                </li>
                <li className={classes.contactList}>
                  <MdPhoneInTalk />
                  <Link to="tel:+442475420877">+44 247 542 0877</Link>
                </li>

                <div className={classes.contactListEnvelope}>
                  <li>
                    <div className={classes.emailIcon}>
                      <FaEnvelope />
                    </div>

                    <div className={classes.emailContent}>
                      <Link to="mailto:sales@serverstock.co.uk">
                        sales@serverstock.co.uk
                      </Link>
                      <Link to="mailto:support@serverstock.co.uk">
                        support@serverstock.co.uk
                      </Link>
                    </div>
                  </li>
                </div>

                <li className={classes.contactList}>
                  <FaCalendarAlt />
                  <p>Mon - Fri / 8:00 AM - 5:00 PM (GMT)</p>
                </li>
                <li className={classes.contactList}>
                  <FaRegBuilding />
                  <p>
                    <strong>Company Number:</strong> 15092277
                  </p>
                </li>

                <li className={classes.contactList}>
                  <RiBillLine />
                  <p>
                    <strong>VAT NUMBER:</strong> 470 1198 06
                  </p>
                </li>
              </ul>
            </div>
          </div>

          <div className={classes.footerBottom}>
            <h4>
              © {currentYear}{" "}
              <Link to="https://www.serverstock.co.uk" className={classes.link}>
                Server Stock
              </Link>
              . All rights reserved.
            </h4>
            <img src="/payment-card.png" alt="Server Stock" />
          </div>
        </div>
      </div>
    </div>
  );
}
